import React from "react";

interface CustomCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

/**
 * Checkbox custom moderno con stile GearSurfing
 * Usa i colori primary (viola) del tema
 * Compatibile con react-hook-form
 */
export const CustomCheckbox = React.forwardRef<
  HTMLInputElement,
  CustomCheckboxProps
>(
  (
    {
      checked,
      onChange,
      label,
      name,
      id,
      className = "",
      disabled = false,
      onBlur,
      value,
      ...rest
    },
    ref
  ) => {
    const checkboxId =
      id || `checkbox-${name || Math.random().toString(36).substr(2, 9)}`;
    const [internalChecked, setInternalChecked] = React.useState(false);

    // Usa il valore controllato se fornito, altrimenti usa lo stato interno
    const isChecked = checked !== undefined ? checked : internalChecked;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (checked === undefined) {
        setInternalChecked(e.target.checked);
      }
      onChange?.(e);
    };

    return (
      <label
        htmlFor={checkboxId}
        className={`inline-flex items-center cursor-pointer group ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        } ${className}`}
      >
        <div className="relative">
          <input
            ref={ref}
            type="checkbox"
            id={checkboxId}
            name={name}
            checked={isChecked}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            className="sr-only peer"
            value={value}
            {...rest}
          />
          {/* Custom checkbox box */}
          <div
            className={`
              w-5 h-5 rounded-md border transition-all duration-200 ease-in-out
              ${
                isChecked
                  ? "bg-secondary border-secondary"
                  : "bg-black/20 border-white/20 group-hover:border-primary/50"
              }
              ${disabled ? "" : "group-hover:scale-110 shadow-sm"}
              flex items-center justify-center
            `}
          >
            {/* Checkmark icon */}
            {isChecked && (
              <svg
                className="w-3.5 h-3.5 text-white animate-scale-in"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3.5"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M5 13l4 4L19 7"></path>
              </svg>
            )}
          </div>
        </div>
        {label && (
          <span className="ml-2.5 text-sm text-white/90 select-none group-hover:text-white transition-colors">
            {label}
          </span>
        )}
      </label>
    );
  }
);

CustomCheckbox.displayName = "CustomCheckbox";
